import React from "react";

interface SectionBadgeProps {
  title: string;
  color?: string;
}

const SectionBadge = ({ title, color = "#188F46" }: SectionBadgeProps) => {
  return (
    <section className={`bg-[${color}] w-full`}>
      <div className="container mx-auto h-[80px] flex items-center justify-center px-4">
        <h2 className="text-2xl text-white font-bold text-center">{title}</h2>
      </div>
    </section>
  );
};

export default SectionBadge;
